<template>
  <div class="dea-purchase-info dea-heading--light__xs">
    Hai acquistato un corso e non puoi più partecipare? <br />
    Consulta le
    <Links
      :href="config.purchaseInfo_url"
      class-name="dea-links dea-links--generic-dark-grey"
      label-class="dea-heading--medium__s"
      target="_blank"
      >condizioni di vendita</Links
    >.
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Links from "@/components/elements/Links";

export default {
  name: "PurchaseInfo",
  components: {
    Links,
  },
  computed: {
    ...mapGetters(["config"]),
  },
};
</script>
<style lang="scss">
@import "@/styles/system.utils";

.dea-purchase-info {
  margin: 0 $space-large $space-base $space-large;
}
</style>
